import * as mobx from 'mobx';
import { IntlShape } from 'react-intl';
import { ICreateRoleDTO } from '../../../api/roles.dao';
import { MEDIUM_PLAIN_TEXT_LENGTH, SHORT_PLAIN_TEXT_64_LENGTH } from '../../../constants/common.constants';

class RoleFormDataVM {

    public defaultValues = {
        name: '',
        description: '',
    };

    @mobx.observable
    public name: string = this.defaultValues.name;

    @mobx.observable
    public description: string = this.defaultValues.description;

    @mobx.observable
    private isFormChecked: boolean;

    @mobx.observable
    public serverErrorMessage: string;

    @mobx.observable
    public validationError: string[];

    @mobx.action
    public setName = (name: string) => {
        this.serverErrorMessage = '';
        this.name = name;
    };
    @mobx.action
    public setDescription = (description: string) => {
        this.serverErrorMessage = '';
        this.description = description;
    };

    public getNameError(intl: IntlShape): string | null {
        if (!this.name) {
            return intl.formatMessage({
                id: `oe.common.nameIsRequired`,
                defaultMessage: 'Name is required',
                description: 'Error message in user popover'
            });
        } else if (this.name?.length > SHORT_PLAIN_TEXT_64_LENGTH) {
            return intl.formatMessage({
                id: `oe.validation.shortPlainText64TooLong`,
                defaultMessage: 'Too long - max length is 64 characters',
                description: 'Error message text'
            });
        }

        return null;
    }

    public getDescriptionError(intl: IntlShape): string | null {
        if (this.description?.length > MEDIUM_PLAIN_TEXT_LENGTH) {
            return intl.formatMessage({
                id: `oe.validation.mediumPlainTextTooLong`,
                defaultMessage: 'Too long - max length is 2048 characters',
                description: 'Error message text'
            });
        }

        return null;
    }

    public isFormValid(intl: IntlShape): boolean {
        return !this.getNameError(intl)
            && !this.getDescriptionError(intl);
    }

    @mobx.action
    public allowToShowValidationErrors(): void {
        this.isFormChecked = true;
    }

    public showValidationErrors(): boolean {
        return this.isFormChecked;
    }

    public toApiRoleDTO(): ICreateRoleDTO {
        return {
            name: this.name.trim(),
            description: this.description.trim()
        };
    }

    public toApiEditRoleDTO(): ICreateRoleDTO {
        return {
            name: this.name.trim(),
            description: this.description.trim(),

        };
    }
}

export { RoleFormDataVM };